import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { readyForPrerender } from '@xanadu/ui-shared/utils/prerender';

export default class MBHelmet extends PureComponent {
  static get propTypes() {
    return {
      location: PropTypes.shape({
        pathname: PropTypes.string.isRequired
      })
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      previousPathname: this.props.location ? this.props.location.pathname : '',
      showHelmet: false
    };
  }


  componentWillReceiveProps({ location: { pathname } }) {
    if (pathname !== this.state.previousPathname) {
      readyForPrerender();
      this.setState({
        showHelmet: true
      });
    } else {
      this.setState({
        showHelmet: false
      });
    }
  }

  render() {
    if (this.state.showHelmet) {
      return (
        <Helmet
          defaultTitle="Matchbook.com - Sports Betting Exchange, Lowest Commissions, Best Odds Online"
        >
          <meta
            name="prerender-status-code"
            content="301"
          />
          <meta
            name="prerender-header"
            content={`Location: https://www.matchbook.com${this.props.location.pathname}`}
          />
        </Helmet>
      );
    }

    return null;
  }
}
